import { Model } from '@/model/Model'
import { BetCooldownState } from '@/states/reels_spinning/BetCooldownState'
import { BaseParentState } from '@stateMachine/BaseParentState'
import { IStateMachine } from '@stateMachine/IStateMachine'
import { GameStatesEnum } from '../GameStatesEnum'
import { FreeSpinsActivateState } from '@/states/freespins/FreeSpinsActivateState'
import { FreeSpinsIntroState } from '@/states/freespins/FreeSpinsIntroState'
import { FreeSpinsSummaryState } from '@/states/freespins/FreeSpinsSummaryState'
import { MultiplierState } from '@/states/cascade/MultiplierState'
import { FreeSpinsRetriggerState } from '@/states/freespins/FreeSpinsRetriggerState'
import { BigWinState } from '@/states/winings/BigWinState'
import GameSignals from '@/signals/GameSignals'
import { SharedPopupManager } from '@dragonframework/modules'

export class FinalState extends BaseParentState {
    public constructor(stateMachine: IStateMachine, model: Model, id: string) {
        super(stateMachine, model, id)

        /** final winnings states **/
        this.addChild(MultiplierState, GameStatesEnum.MULTIPLIER_STATE)
        this.addChild(BigWinState, GameStatesEnum.BIG_WIN_STATE)
        this.addChild(BetCooldownState, GameStatesEnum.BET_COOLDOWN_STATE)

        /** free spins states **/
        this.addChild(FreeSpinsActivateState, GameStatesEnum.FREE_SPINS_ACTIVATE_STATE)
        this.addChild(FreeSpinsIntroState, GameStatesEnum.FREE_SPINS_INTRO_STATE)
        this.addChild(FreeSpinsRetriggerState, GameStatesEnum.FREE_SPINS_RETRIGGER_STATE)
        this.addChild(FreeSpinsSummaryState, GameStatesEnum.FREE_SPINS_SUMMARY_STATE)
    }

    public begin() {
        super.begin()
        GameSignals.finalState.emit()
    }

    public end = () => {
        // Se c'è una promo offer in attesa di conferma, andiamo in STOP_ROUND per mostrare la popup
        if (SharedPopupManager.isPromoOfferPendingConfirmation) {
            console.log('[FinalState] promo offer pending, going to STOP_ROUND instead of auto-spinning')
            this._stateMachine.setState(GameStatesEnum.STOP_ROUND_STATE)
            return
        }
        
        if (this._model.spinData?.freebet && this._model.spinData.freebet.amount_left > 0) {
            this._stateMachine.setState(GameStatesEnum.START_SPIN_STATE)
        } else {
            this._stateMachine.setState(GameStatesEnum.STOP_ROUND_STATE)
        }
    }
}
